import script from "./DeptManage.vue?vue&type=script&setup=true&lang=js"
export * from "./DeptManage.vue?vue&type=script&setup=true&lang=js"

import "./DeptManage.vue?vue&type=style&index=0&id=22b42242&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b42242"]])

export default __exports__